import React, { useEffect } from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineV2"
import useGetBenefit from "#/components/dynamic-content/hooks/useGetBenefit"
import { useFlags } from "launchdarkly-react-client-sdk"

function GenderIdentityDecisionStepContent({ isPartnerSection }: { isPartnerSection: boolean }): JSX.Element {
  const benefitConfiguration = useGetBenefit()
  const lgbtqEnabled = benefitConfiguration.data?.generalSupport.showLgbtqContent
  const { movingAddressIntakeToRegistration } = useFlags()
  const { send } = useStateMachine(null)

  useEffect(() => {
    if (lgbtqEnabled) {
      send("YES")
      return
    }
    if (isPartnerSection) {
      send("NO")
      return
    }
    send(movingAddressIntakeToRegistration ? "SKIP_ADDRESS" : "NO")
  }, [lgbtqEnabled, isPartnerSection, movingAddressIntakeToRegistration, send])
  return <></>
}

export function AboutYouGenderIdentityDecisionStep(): JSX.Element {
  return <GenderIdentityDecisionStepContent isPartnerSection={false} />
}

export function PartnerGenderIdentityDecisionStep(): JSX.Element {
  return <GenderIdentityDecisionStepContent isPartnerSection />
}
